import React, { useState } from 'react'

import { useDispatch, useStore } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { getCookieNameByDietType } from 'routes/Menu/hooks/useIsAddAProteinPaintedDoorEnabled'
import { getUserFirstName } from 'selectors/user'
import Cookies from 'utils/GoustoCookies'

import { RecipeCustomisationSection } from './RecipeCustomisationSection'
import { getCustomisationForRecipe } from './getCustomisationForRecipe'

export type IngredientCustomisationProps = {
  dietType?: string
  recipeId: string
}

const RecipeCustomisationContainer: React.FC<IngredientCustomisationProps> = ({
  dietType,
  recipeId,
}) => {
  const customisation = getCustomisationForRecipe(dietType)
  const cookieName = getCookieNameByDietType(dietType)

  const store = useStore()
  const dispatch = useDispatch()
  const { basket } = store.getState()

  const [checked, setChecked] = useState<boolean>(false)
  const [timeoutId, setTimeoutId] = useState<number | null>(null)
  const [shouldShowConfirmationDialogue, setShouldShowConfirmationDialogue] =
    useState<boolean>(false)

  const firstName = getUserFirstName(store.getState())

  const setOrCancelTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      setTimeoutId(null)

      return
    }

    setTimeoutId(
      window.setTimeout(() => {
        setShouldShowConfirmationDialogue(true)
        dispatch({
          type: actionTypes.TRACKING,
          trackingData: {
            actionType: 'ui_interaction',
            element_name: 'add_protein',
            menuId: basket.get('currentMenuId'),
            orderId: basket.get('orderId'),
            proteinOption: customisation?.trackingSlug,
            recipeId,
          },
        })

        if (cookieName) {
          Cookies.set(cookieName, 1)
        }
      }, 2000),
    )
  }

  if (!customisation) {
    return null
  }

  return (
    <RecipeCustomisationSection
      checked={checked}
      customisation={customisation}
      firstName={firstName}
      onClick={() => {
        setChecked(!checked)
        setOrCancelTimeout()
      }}
      shouldShowConfirmationDialogue={shouldShowConfirmationDialogue}
      recipeId={recipeId}
    />
  )
}

export { RecipeCustomisationContainer }
